module.exports = __webpack_public_path__ + "static/top-skills-to-succeed-remote-job-marketplace-94a5900aa7737720946817268b6ec1d3.png";